export default __webpack_public_path__ + "static/media/Adzuna_Logo.18ef8f09.svg";